interface Faq {
  id: string;
  title: string;
  text: string;
}

// TODO: ADD REAL FAQ ITEMS
export const faqItems: Faq[] = [
  {
    id: "1",
    title: "Is there a fee for your services?",
    text: "Yes, our fees are determined by the complexity of the case. We only charge if we identify potential for money recovery; otherwise, we do not take on the case.",
  },
  {
    id: "2",
    title: "Why choose Online Justice's services?",
    text: `The Experts on Your Side

We possess the expertise, the experience, and specialized training necessary to locate and track your scammers and money.

Communication from Start to Finish

From your initial contact with us, we maintain open lines of communication including video calls, ensuring you're informed every step of the way.

Fair Pricing

We offer a transparent pricing structure for our services, providing clarity on the costs involved. Unlike others, we don't take a percentage from your stolen funds. Instead, we charge based on the specific services required, ensuring fairness and clarity throughout the process.

Fair Dealing

We manage your expectations. At Online Justice, we never make promises we can't keep. We ensure you know exactly what to expect in terms of financial recovery from your scammers.`,
  },
  {
    id: "3",
    title: "Will I have a withdrawal fee at the end of the process?",
    text: "No, you will not incur a withdrawal fee at the end of the process. Since we are not a recovery company, your recovered funds do not go through us. Any fees associated with our services will be clearly communicated upfront.",
  },
  {
    id: "4",
    title: `Is your pricing method "no win, no fee"?`,
    text: `No, our pricing method is different. Since we are not a law firm or a recovery company, we do not operate on a "no win, no fee" basis. As a Cyber Intelligence company, we provide our clients with actionable data to help them recover their money. We charge fixed fees for our services, which vary depending on the complexity of the case. All fees are communicated upfront to ensure transparency.`,
  },
  {
    id: "5",
    title: `Which payment methods do you accept?`,
    text: `We accept credit cards, bank wire transfers, Apple Pay, and Google Pay. Our acceptance of these payment methods underscores our legitimacy as a company. To open a bank account, we must present business certification and undergo identification processes. Similarly, working with credit card payments allows for traceability and accountability. This transparency demonstrates that we are a legitimate company, committed to providing trustworthy services.`,
  },
];
